module.exports = __webpack_public_path__ + "img/wechat.3e936e58.png";